import { DataGrid, GridOverlay} from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React from 'react';
import {mainInfoStorage} from '../../services/ocr/MainInfoStorageModel';
import { Typography } from '@mui/material';
import { translationService } from '../../services/translation/TranslationService';

interface IMainInfoTable {
  mainInfoStorage: typeof mainInfoStorage;
}

const customOverlay = () => {
      return (
        <GridOverlay>
            <Typography variant="h6" >
              {translationService.translate("ocrService.mainInfoTable.noMainInfo")}
            </Typography>
        </GridOverlay>
      );
    }

export const MainInfoTable = observer(({ mainInfoStorage }: IMainInfoTable) => {
  return (
    <div className="base-data-table">
      <Typography variant="h6" sx={{ mb: 1 }}>
        {translationService.translate("ocrService.mainInfo.table-name")}
      </Typography>
      <DataGrid
        rows={mainInfoStorage.rows}
        columns={mainInfoStorage.columns}
        autoHeight
        hideFooter
        slots={{ noRowsOverlay: customOverlay, columnHeaders: () => null }}
      />
    </div>
  );
});

